Vue = require 'vue'

require 'bootstrap'

view = (view_name) ->
  require("../views/#{view_name}")

ui_components = {
  contactList: view 'contacts/list'
  contactListItem: view 'contacts/list_item'

  flowListItem: view 'flows/list_item'

  userMiniature: view 'users/miniature'
  confirmModal: view 'shared/modals/confirm'
  loading: view 'shared/loading'
  goToTop: view 'shared/go_to_top'
  backLink: view 'shared/back_link'
  statisticTableCol: view 'shared/statistic_table_col'
  dropdownSelect: view 'shared/dropdown-select'
  dropdownMultipleSelect: view 'shared/dropdown-multiple-select'
  dateRangePicker: view 'shared/date_range_picker'
}

for component_name, component_options of ui_components
  Vue.component component_name, component_options

Vue.component 'datepicker', require 'vuejs-datepicker'

module.exports = ui_components



// WEBPACK FOOTER //
// ./src/libraries/ui.coffee